import { ListItemButton, ListItemButtonProps } from '@mui/material'
import React, { FC } from 'react'

const ListItemButtonWrapper: FC<ListItemButtonProps> = ({ ...props }) => <ListItemButton {...props} />

export default ListItemButtonWrapper
